import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

RevokeDevicesButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
};

function RevokeDevicesButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        disabled = false,
        label = null,
    } = props;
    return (
        <MutationButton
            className="revoke-all-button button-bordered button"
            confirmationMessage={confirmationMessage}
            disabled={disabled}
            extendedMutation={extendedMutation}
        >
            <FontAwesomeIcon icon={'fa-x'} />&nbsp;{label}
        </MutationButton>
    );
}

export default RevokeDevicesButton;